import z from 'zod';

export interface GridQueryOptions {
  entityTypeId: string;
  moduleId: string;

  parentId?: string;
  parentKeyField?: string;

  isLookup?: boolean;
}

const GridQueryOptionsSchema = z.object({
  entityTypeId: z.string(),
  moduleId: z.string(),
  parentId: z.string().optional(),
  parentKeyField: z.string().optional(),
});

// Export types from schemas

export type GridQueryOptionsType = z.infer<typeof GridQueryOptionsSchema>;

// Export schemas
export { GridQueryOptionsSchema };
